import {
  uniqueId
} from 'lodash';
import {
  STAGE_REVIEW
} from '../../../../dictionaries/Engagement.dic';
import MatchPageUI from '../../../../dictionaries/MatchPageUI.dic';
import {
  Arr,
  sanitizeArr
} from '../../../../lib/Array.lib';
import {
  NOT,
  YES
} from '../../../../lib/Boolean.lib';
import Candidate from '../../../../lib/Candidate';
import Engagement from '../../../../lib/Engagement';
import getJobOwnershipTextAndColor from '../../../../lib/GetJobOwnershipTextAndColor';
import {
  mapEngagements
} from '../../../../lib/models/engagement';
import {
  Obj
} from '../../../../lib/Object.lib';
import {
  COLLECTION__ENGAGEMENTS,
  readLoopbackRecord
} from '../../../../lib/services/BE/loopback.api';
import {
  joinKeyName
} from '../../../../lib/String.lib';
import Chip from '../../../Layout/Wrappers/Chip';
import {
  PLACEMENT__TOP_END
} from '../../../Layout/Wrappers/StyledTooltip';
import {
  getMatchEntities,
  isJobBlackListed
} from '../MatchList.lib';

const CACHE = {};
export default async function getOwnershipChip(props) {
  const {
    job = {},
    candidate = {},
  } = getMatchEntities(props);

  // STEP 1: GET CANDIDATE DUPLICATES
  const results = [];
  let color = '';
  let calibrationColor = '';
  CACHE.duplicates = Obj(CACHE.duplicates);
  const duplicates = await (
    CACHE.duplicates[candidate.id] || (
      CACHE.duplicates[candidate.id] = (
        new Promise((resolve) => {
          Candidate.getPotentialDuplicated(candidate, (duplicates) => {
            resolve(duplicates);
          });
        })
      )
    )
  );

  const candidates = [candidate, ...duplicates];

  for (const candidate of candidates) {

    // STEP 2: GET JOB OWNERSHIPS
    candidate.jobOwnerships = Arr(
      await Candidate.getPotentialDuplicatedWithOwnerships(candidate)
    );

    // STEP 3: GET ENGAGEMENTS
    CACHE.candidateEngagements = Obj(CACHE.candidateEngagements);
    candidate.engagements = await (
      CACHE.candidateEngagements[candidate.id] || (
        CACHE.candidateEngagements[candidate.id] = readLoopbackRecord({
          collection: COLLECTION__ENGAGEMENTS,
          where: {
            candidateId: candidate.id,
          },
          include: [
            { candidate: 'account' },
            {
              relation: 'job',
              scope: {
                include: [
                  {
                    relation: 'employer',
                    scope: {
                      include: [
                        'employerBlackList', 'employerSourceList'
                      ]
                    }
                  },
                  'jobBlackList',
                  'jobSourceList',
                ]
              }
            },
          ],
          mapper: mapEngagements,
          source: 'getOwnershipChip',
        })
      )
    );

    // STEP 4: GET JOB OWNERSHIP TEXT AND COLOR
    if (NOT(results.length) && NOT(color)) {
      const YES__CANDIDATE_IS_JOB__BLACKLISTED = isJobBlackListed(candidate, job);
      if (YES__CANDIDATE_IS_JOB__BLACKLISTED) {
        color = MatchPageUI.CardChipBar.OwnerShip.unavailableToCando.color;
        results.push(MatchPageUI.CardChipBar.OwnerShip.unavailableToCando.label);
      }
      else {
        const jobOwnership = getJobOwnershipTextAndColor(
          candidate.jobOwnerships,
          job.employerId,
          candidate.id
        );
        color = jobOwnership.color;
        results.push(jobOwnership.label);
      }
    }

    // STEP 5: GET PRIOR SUBMISSION
    let priorSubText = '';
    const order = Engagement.stageOrder;
    const engagement = Obj(
      candidate.engagements.find(
        (engagement) =>
          Obj(engagement.job).employerId === job.employerId &&
          order.indexOf(engagement.stage) >= order.indexOf(STAGE_REVIEW)
      )
    );
    const isStrongConflictWithEngagement = candidate.jobOwnerships.find(
      (objM) => {
        return (
          objM.isPotentialStrongConflict &&
          !!objM.conflictedEmployers.find(
            (obj) =>
              !!obj.hasEngagement &&
              obj.employerId === job.employerId
          )
        );
      }
    );
    if (!!engagement.id) {
      priorSubText = 'Prior Submission*';
    }
    if (!!isStrongConflictWithEngagement) {
      priorSubText = !!priorSubText.length
        ? priorSubText + '^'
        : 'Prior submission^';
    }
    if (!!priorSubText.length) {
      results.push(priorSubText);
    }

    // STEP 6: GET CALIBRATION
    const engagementWithCalibrationStatus = Obj(
      candidate.engagements.find(
        (engagement) =>
          Obj(engagement.job).employerId === job.employerId
          && engagement.calibrationStatus
      )
    );
    if (YES(engagementWithCalibrationStatus.id)) {
      results.push(`Calibration ${engagementWithCalibrationStatus._calibrationStatus}`);
      calibrationColor = MatchPageUI.CardChipBar.OwnerShip.calibration[
        +engagementWithCalibrationStatus.calibrationStatus
      ]?.color;
    }
  }

  // STEP 7: RETURN CHIPS BASED ON RESULTS
  return sanitizeArr(results).map(
    (label) => (
      <Chip slim
        key={
          joinKeyName(
            [
              'ownership_chip',
              `job_${job.id}`,
              `candidate_${candidate.id}`,
              `label_${label}`,
              uniqueId()
            ]
          )
        }
        style={{
          backgroundColor: label.includes('Calibration')
            ? calibrationColor
            : color
        }}
        className='c-white px-1 mr-05 mb-05 f-md'
        /** 
         * @note 
         * Do not remove this attribute.
         * It is used to extract the label value.
         * @see ownerShipChipLabel on SingleCandidateCard & SingleJobCard.
         */
        data-label={label}
        title={label}
        placement={PLACEMENT__TOP_END}
      >
        {(label)}
      </Chip>
    )
  );
}